import React, { useContext, useEffect, useCallback } from 'react';
import P from 'prop-types';
import InputMask from 'react-input-mask';
import { Button } from '../Button';
import { useForm } from 'react-hook-form';
import { LabelForm } from '../LabelForm';
import { GlobalContext } from '../../contexts/HomeContext';
import { GetUsuario, SaveUser } from '../../utils/utils';

export const Autenticacao = ({ param }) => {
  const { dadosApp, user, setUser } = useContext(GlobalContext);
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleValidForm = (form) => {
    const _telefone = removeMask(form.numeroCelular);
    const arrayOfStrings = form.nomeCompleto.split(' ');
    const _nome = arrayOfStrings.length > 0 ? arrayOfStrings[0] : '';
    const _sobrenome = form.nomeCompleto.replace(_nome, '');

    const _usuario = { ...user };
    _usuario.idloja = dadosApp.IdLoja;
    _usuario.nome = _nome.trim();
    _usuario.sobrenome = _sobrenome.trim();
    _usuario.nome_completo = form.nomeCompleto;
    _usuario.telefone_ddd = _telefone.substring(0, 2);
    _usuario.telefone = _telefone.substring(2);
    // const _usuario = {
    //   id: dadosApp.IdLoja,
    //   idloja: dadosApp.IdLoja,
    //   nome: _nome.trim(),
    //   sobrenome: _sobrenome.trim(),
    //   nome_completo: form.nomeCompleto,
    //   email: '',
    //   senha: '',
    //   telefone_ddd: _telefone.substring(0, 2),
    //   telefone: _telefone.substring(2),
    //   empresa_fantasia: '',
    //   empresa_razao: '',
    //   data_aniversario: '2011-01-01',
    //   cpf: '',
    //   sexo: 'Masculino',
    //   geolocation: {
    //     IPv4: '',
    //     city: null,
    //     country_code: '',
    //     country_name: '',
    //     latitude: 0,
    //     longitude: 0,
    //     postal: null,
    //     state: null,
    //   },
    // };

    SaveUser(dadosApp.IdLoja, _usuario, setUser);
    param.showHideModal();
    param.onClick();
  };

  const removeMask = (el) => {
    let element = el;
    for (let index = 0; index < el.length; index++) {
      element = element.replace('+55', '');
      element = element.replace('_', '');
      element = element.replace('/', '');
      element = element.replace(' ', '');
    }
    return element;
  };

  const handleSetUser = useCallback(
    (_usuario, _idLoja) => {
      SaveUser(_idLoja, _usuario, setUser);
      setValue('nomeCompleto', _usuario.nome_completo, {
        shouldValidate: true,
        shouldDirty: true,
      });
      if (_usuario.telefone_ddd) {
        setValue('numeroCelular', _usuario.telefone_ddd + _usuario.telefone, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    },
    [setValue, setUser],
  );

  const handleGetUsuario = useCallback(async () => {
    if (user.id === 0) {
      const usuario = GetUsuario(dadosApp.IdLoja);
      if (usuario) handleSetUser(usuario, dadosApp.IdLoja);
    } else {
      handleSetUser(user);
    }
  }, [user, handleSetUser, dadosApp.IdLoja]);

  useEffect(() => {
    handleGetUsuario();
  }, [handleGetUsuario]);

  return (
    <div style={{ margin: '20px 40px 30px', textAlign: 'center' }}>
      <p style={{ paddingBottom: '20px', textAlign: 'center' }}>{param.title}</p>

      <form
        onSubmit={handleSubmit(handleValidForm)}
        className="modal-content-dialog padTop20"
        style={{ borderTop: 0, padding: '15px 0px 0 0px' }}
      >
        <div className="form-container">
          <LabelForm text="Nome Completo" />
          <input
            type="text"
            placeholder=""
            disabled={user.ativo}
            className="form-control"
            {...register('nomeCompleto', {
              validate: (value) => value !== '',
            })}
          />
          {errors.nomeCompleto && <p className="form-errors">Informe o seu nome completo</p>}
        </div>
        <div className="form-container">
          <LabelForm text="Celular com ddd" />
          <InputMask
            type="tel"
            placeholder=""
            disabled={user.ativo}
            className="form-control"
            mask={'+5\\5 99 99999 9999'}
            maskChar=" "
            alwaysShowMask={false}
            {...register('numeroCelular', {
              validate: (value) => {
                const _telefone = removeMask(value);
                return _telefone.length === 11;
              },
            })}
          />

          {errors.numeroCelular && <p className="form-errors">Telefone Inválido</p>}
        </div>

        <div className="padTop20 padBottom20">
          {/* <Button type="submit" text="Salvar" textAlign="center" className="btn_1 full-width btnRounded" /> */}
          <Button type="submit" icon="check" className="btnRounded" />
        </div>
      </form>

      {/* <div style={{ padding: '20px 0' }}>
        <Button icon="check" className="btnRounded" onClick={() => handleClick(value)} />
      </div> */}
    </div>
  );
};

Autenticacao.propTypes = {
  param: P.object,
};
